namespace TabAurous.Inventory {
    export namespace SKURepricingDetailsBOMService {
        export const baseUrl = 'Inventory/SKURepricingDetailsBOM';

        export declare function Create(request: Serenity.SaveRequest<SKURepricingDetailsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SKURepricingDetailsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SKURepricingDetailsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SKURepricingDetailsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/SKURepricingDetailsBOM/Create",
            Update = "Inventory/SKURepricingDetailsBOM/Update",
            Delete = "Inventory/SKURepricingDetailsBOM/Delete",
            Retrieve = "Inventory/SKURepricingDetailsBOM/Retrieve",
            List = "Inventory/SKURepricingDetailsBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SKURepricingDetailsBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
